export const AWAY_MESSAGE = 'AWAY_MESSAGE';
export const HIDE_CHAT_LAUNCHER = 'HIDE_CHAT_LAUNCHER';
export const DO_NOTHING = 'DO_NOTHING';
export const SHOW_NEXT_OFFICE_HOURS_TIME = 'SHOW_NEXT_OFFICE_HOURS_TIME';